module.exports = __webpack_public_path__ + "static/media/BANNER-FERRETERIA-.2c6f5ccd.png";